import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Clock } from "lucide-react";
import { useFetch, fmtDate, usePageTitle } from "@/lib/api";
import { IMG } from "@/lib/content";
import { PageHero, Loading, Reveal, EmptyState } from "@/components/site/Bits";

export default function Events() {
  usePageTitle("Events & Tournaments");
  const { data, loading } = useFetch("/content/events");
  const events = [...(data || [])].sort((a, b) => (a.date || "9999").localeCompare(b.date || "9999"));
  return (
    <div data-testid="events-page">
      <PageHero testid="events-hero" eyebrow="Events & Tournaments" image={IMG.stadium}
        title={<>The 2027<br /><span className="text-gold">Allstar Calendar</span></>}
        sub="Tryouts, the AUG Florida Showcase and the AUG National Allstars Classic." />
      <section className="bg-pitch py-16 sm:py-24">
        <div className="wrap">
          {loading ? <Loading /> : events.length === 0 ? <EmptyState title="No events posted" testid="events-empty" /> : (
            <div className="space-y-4" data-testid="events-list">
              {events.map((e, i) => (
                <Reveal key={e.id} delay={i * 0.05}>
                  <Link to={`/events/${e.slug || e.id}`} className="group grid grid-cols-[88px_1fr] sm:grid-cols-[140px_1fr_auto] items-stretch bg-ink border border-line hover:border-gold transition-colors" data-testid={`event-row-${e.slug || e.id}`}>
                    <div className="flex flex-col items-center justify-center bg-navy group-hover:bg-gold transition-colors p-4">
                      <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.2em] text-gold group-hover:text-navy">{e.date ? fmtDate(e.date, { month: "short" }) : "TBA"}</p>
                      <p className="font-display text-4xl sm:text-6xl font-black italic leading-none group-hover:text-navy">{e.date ? fmtDate(e.date, { day: "numeric" }) : "—"}</p>
                      <p className="font-mono text-[10px] text-slate-400 group-hover:text-navy">{e.date ? fmtDate(e.date, { year: "numeric" }) : ""}</p>
                    </div>
                    <div className="p-5 sm:p-7 min-w-0">
                      <span className="bg-gold/10 border border-gold/40 px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest text-gold">{e.category || "Event"}</span>
                      <p className="mt-3 font-display text-2xl sm:text-4xl font-black uppercase italic leading-none">{e.title}</p>
                      <div className="mt-3 flex flex-wrap gap-x-5 gap-y-1 text-sm text-slate-400">
                        <span className="flex items-center gap-1.5"><MapPin className="h-4 w-4 text-gold" />{e.location}</span>
                        {e.time_info && <span className="flex items-center gap-1.5"><Clock className="h-4 w-4 text-gold" />{e.time_info}</span>}
                      </div>
                    </div>
                    <div className="hidden sm:flex items-center px-8"><ArrowUpRight className="h-8 w-8 text-slate-500 group-hover:text-gold group-hover:rotate-45 transition-transform" /></div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
